import { useAppStore } from '@/dashboard/store/appStore';
import { storeToRefs } from 'pinia';
import { BaseWorkspace, WorkspaceWithUser } from '@/dashboard/types/workspace';
import { UserRole, UserRoleType } from '@/dashboard/types/user_role';
import { openCreateProject } from '@/dashboard/utils/project/openCreateProject';
import { openCreateWorkspace } from '@/dashboard/utils/workspace/openCreateWorkspace';

export function useSideMenuInner() {
  const appStore = useAppStore();

  const { workspaces, sharedProjects, currentUser } = storeToRefs(appStore);

  function isCanAddProject(workspace: WorkspaceWithUser) {
    const roles: UserRoleType[] = [UserRole.Owner, UserRole.Admin, UserRole.Creator];
    const role: UserRoleType | undefined = workspace.user?.role;

    return !!role && roles.includes(role);
  }

  function createWorkspace() {
    openCreateWorkspace();
  }

  async function createProject(workspace: BaseWorkspace) {
    await openCreateProject(workspace.id);
  }

  return { workspaces, currentUser, sharedProjects, isCanAddProject, createWorkspace, createProject };
}
